// web/src/pages/Dashboard.jsx
import React, { useEffect, useState } from "react";
import "./Dashboard.css";

// ====== METRICS CARDS ======
import TotalUsersCard from "../components/metrics/TotalUsersCard";
import ActiveUsersCard from "../components/metrics/ActiveUsersCard";
import CompletedProfilesCard from "../components/metrics/CompletedProfilesCard";
import IaSessionsCard from "../components/metrics/IaSessionsCard";
import MatchesCard from "../components/metrics/MatchesCard";
import PremiumUsersCard from "../components/metrics/PremiumUsersCard";
import CitiesCard from "../components/metrics/CitiesCard";
import GenderCard from "../components/metrics/GenderCard";
import AgeCard from "../components/metrics/AgeCard";
import PlansCard from "../components/metrics/PlansCard";

// ✅ NOVOS CARDS DO TOPO
import PlusPlanTotalCard from "../components/metrics/PlusPlanTotalCard";
import PremiumPlanTotalCard from "../components/metrics/PremiumPlanTotalCard";
import DiamondPlanTotalCard from "../components/metrics/DiamondPlanTotalCard";
import EstimatedRevenueTotalCard from "../components/metrics/EstimatedRevenueTotalCard";

// ====== BASIC CHARTS ======
import UsersGrowthChart from "../components/charts/UsersGrowthChart";
import CitiesPieChart from "../components/charts/CitiesPieChart";
import GenderPieChart from "../components/charts/GenderPieChart";
import PlansPieChart from "../components/charts/PlansPieChart";

// ====== ADVANCED FULL-WIDTH CHARTS ======
import HourlyActiveHeatmap from "../components/charts/HourlyActiveHeatmap";
import RetentionChart from "../components/charts/RetentionChart";
import NewUsersChart from "../components/charts/NewUsersChart";
import RealtimeActiveChart from "../components/charts/RealtimeActiveChart";

// ====== SERVICES ======
import { getDashboardMetrics } from "../services/dashboardService";

export default function Dashboard() {
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);

  // ==========================================
  // 🔥 Carrega métricas REAIS do Firestore
  // ==========================================
  useEffect(() => {
    async function loadMetrics() {
      try {
        const data = await getDashboardMetrics();
        setMetrics(data);
      } catch (error) {
        console.error("Erro ao carregar métricas do dashboard:", error);
      } finally {
        setLoading(false);
      }
    }

    loadMetrics();
  }, []);

  // ==========================================
  // LOADING STATE
  // ==========================================
  if (loading || !metrics) {
    return (
      <div className="dashboard-container">
        <div className="dashboard-inner">
          <h2 className="dashboard-loading">Carregando métricas...</h2>
        </div>
      </div>
    );
  }

  // ==========================================
  // RENDER FINAL
  // ==========================================
  return (
    <div className="dashboard-container">
      <div className="dashboard-inner">
        {/* Títulos */}
        <h1 className="dashboard-title">Dashboard ❤️ One Love</h1>
        <p className="dashboard-subtitle">
          Bem-vindo ao painel administrativo do One Love.
        </p>

        {/* ✅ LINHA 1 — PLANOS + RECEITA TOTAL (com valor por plano) */}
        <div className="cards-container">
          <PlusPlanTotalCard
            users={metrics.plusUsers}
            revenue={metrics.plusRevenueMonthly}
          />

          <PremiumPlanTotalCard
            users={metrics.premiumPlanUsers}
            revenue={metrics.premiumRevenueMonthly}
          />

          <DiamondPlanTotalCard
            users={metrics.diamondUsers}
            revenue={metrics.diamondRevenueMonthly}
          />

          <EstimatedRevenueTotalCard value={metrics.estimatedRevenueTotalMonthly} />
        </div>

        {/* ======= LINHA 2 — Estatísticas Gerais ======= */}
        <div className="cards-container">
          <TotalUsersCard value={metrics.totalUsers} />
          <ActiveUsersCard value={metrics.activeUsersToday} />
          <CompletedProfilesCard value={metrics.completedProfilesPercent} />
          <IaSessionsCard value={metrics.iaSessions24h} />
        </div>

        {/* ======= LINHA 3 ======= */}
        <div className="cards-container">
          <MatchesCard value={metrics.matchesWeek} />
          <PremiumUsersCard value={metrics.premiumUsers} />
          <CitiesCard value={metrics.citiesCount} />
        </div>

        {/* ======= LINHA 4 — Distribuições ======= */}
        <div className="cards-container">
          <GenderCard distribution={metrics.genderDistribution} />
          <AgeCard distribution={metrics.ageDistribution} />
          <PlansCard distribution={metrics.plansDistribution} />
        </div>

        {/* ====== GRÁFICOS PRINCIPAIS (GRID) ====== */}
        <h2 className="section-title">Análises detalhadas 📊</h2>

        <div className="charts-grid">
          <UsersGrowthChart />
          <CitiesPieChart />
          <GenderPieChart />
          <PlansPieChart />
        </div>

        {/* ========================================== */}
        {/* 🔥 ATIVIDADE & COMPORTAMENTO (FULL-WIDTH) */}
        {/* ========================================== */}
        <h2 className="section-title">Atividade & Comportamento 🔥</h2>

        <div className="charts-block">
          <HourlyActiveHeatmap />
          <RetentionChart />
          <NewUsersChart />
        </div>

        {/* ========================================== */}
        {/* ⚡ TEMPO REAL (FULL-WIDTH) */}
        {/* ========================================== */}
        <h2 className="section-title">Tempo Real ⚡</h2>

        <div className="charts-block">
          <RealtimeActiveChart />
        </div>
      </div>
    </div>
  );
}
